// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Rana backend API
 * The API service for Rana.
 *
 * The version of the OpenAPI document: v1-alpha
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { LayersInner1 } from "./LayersInner1";
import {
  LayersInner1FromJSON,
  LayersInner1FromJSONTyped,
  LayersInner1ToJSON,
  LayersInner1ToJSONTyped,
} from "./LayersInner1";

/**
 *
 * @export
 * @interface FolderOutput
 */
export interface FolderOutput {
  /**
   *
   */
  type?: FolderOutputTypeEnum;
  /**
   *
   */
  name: string;
  /**
   *
   */
  layers?: Array<LayersInner1>;
}

/**
 * @export
 */
export const FolderOutputTypeEnum = {
  Folder: "folder",
} as const;
export type FolderOutputTypeEnum = (typeof FolderOutputTypeEnum)[keyof typeof FolderOutputTypeEnum];

/**
 * Check if a given object implements the FolderOutput interface.
 */
export function instanceOfFolderOutput(value: object): value is FolderOutput {
  if (!("name" in value) || value["name"] === undefined) return false;
  return true;
}

export function FolderOutputFromJSON(json: any): FolderOutput {
  return FolderOutputFromJSONTyped(json, false);
}

export function FolderOutputFromJSONTyped(json: any, ignoreDiscriminator: boolean): FolderOutput {
  if (json == null) {
    return json;
  }
  return {
    type: json["type"] == null ? undefined : json["type"],
    name: json["name"],
    layers:
      json["layers"] == null ? undefined : (json["layers"] as Array<any>).map(LayersInner1FromJSON),
  };
}

export function FolderOutputToJSON(json: any): FolderOutput {
  return FolderOutputToJSONTyped(json, false);
}

export function FolderOutputToJSONTyped(
  value?: FolderOutput | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    type: value["type"],
    name: value["name"],
    layers:
      value["layers"] == null ? undefined : (value["layers"] as Array<any>).map(LayersInner1ToJSON),
  };
}
